import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  ClientSelection,
  ClientSelectionTableHeaderForMasterGrp
} from '../../models/client-selection.model';
import {CustomSortService, SharedService, SharedConstant, EmtrPagination, EmtrPaginationValues} from '@ems/shared';
import {RuleService} from '../../services/rule-service/rule.service';
import {emtrConstant} from '../../constants/emtrConstants';
import * as temp from 'moment';
const moment = temp['default'];
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {FormDataService} from '@ems/shared';
import {MessageService} from 'primeng/api';
import {Paginator} from 'primeng/paginator';
import { TableRowSelectEvent, TableRowUnSelectEvent, TableSelectAllChangeEvent } from 'primeng/table';

@Component({
  selector: 'tr-client-selection-table',
  templateUrl: './client-selection-table.component.html'
})
export class ClientSelectionTableComponent implements OnInit {

  @ViewChild('p') paginator: Paginator;

  @Output() selectedClients: any = new EventEmitter();
  @Output() rowSelected: any = new EventEmitter();
  @Output() selectedMasterAccounts: any = new EventEmitter();
  @Output() unAssignSelectedMstrAccts: any = new EventEmitter();
  @Output() newlySelectedMasterAccounts: any = new EventEmitter();
  @Output() clientsSelection: any = new EventEmitter();
  @Input() assignMasterAcctFormData: any;
  @Input() moduleType: any;
  @Input() mstrAcctData: any;
  @Input() masterGroupMode: any;
  @Input() enableParentCheckbox = true;

  getSharedConstant = SharedConstant;
  clientSelectionTableHeader: ClientSelection[] = ClientSelectionTableHeaderForMasterGrp;
  clientList = [];
  pageObject: EmtrPagination = EmtrPaginationValues;
  multiSortMeta: any = [];
  emtrConstant = emtrConstant;
  moment = moment;
  totalClients: any = 0;
  toggle = false;
  clientsForGlobalRule: UntypedFormGroup;
  selectedOrgIDArr: any = [];
  selection = false;
  unAssignOrgIdsArray: any[] = [];
  unAssignOrgIds: any[] = [];
  assignFormData: any;
  filterBtnDisable = false;
  isfilterClicked = false;
  allClientInfo: any = {};
  selectedMastrArr = [];
  selectedArr = [];
  getCompanyGrpEmpCount: any = 0;
  getCompanyGrpAccCount: any = 0;
  chkCompanyGrp: any;
  validateCompanyGrp: any;
  errMsg = [];
  invalidMasterAcc = false;
  selectedNewRecords = [];
  alreadySelectedRemoval: any = [];
  subAccntNewlySelected: any = [];
  unModifiedRecords: any = [];
  isSortingChanged = false;
  defaultSortDataField = {field: 'updTs', order: -1};
  sortClearButtonReset = false;
  initialLoad = false;
  newAllSelectedClients: any[] = [];
  constructor(private fb: UntypedFormBuilder, @Inject('entitlementConst') public entitlementConst, public sharedService: SharedService,
              public customSortService: CustomSortService, public ruleService: RuleService, public formDataService: FormDataService,
              private el: ElementRef, public messageService: MessageService, private cdr: ChangeDetectorRef) {
    this.assignFormData = this.formDataService.getFormData();
  }

  ngOnInit() {
    this.initialLoad = true;
    this.clientsForGlobalRule = this.fb.group({
      masterAccount: ['']
    });
    this.pageObject.pageNo = 0;
    this.pageObject.pageSize = 15;
    this.sharedService.tableDropdownVal.next(15);
    this.allClientInfo = this.emtrConstant.ruleSteps.step3.allClientInfo;
    this.multiSortMeta.push(this.defaultSortDataField);
    this.onChanges();
    this.resetFilterForm();
    this.cdr.detectChanges();
  }

  resetFilterForm() {
    this.sharedService.resetFilterForm.subscribe(val => {
      /* if user changes the tab then it will reset the filter form for previous active tab but won't make any API call for that */
      if (val.tabChange && this.clientsForGlobalRule.dirty) {
        this.clientsForGlobalRule.reset();
        this.sharedService.clearValidationFields();
        this.clientsForGlobalRule.markAsPristine();
        this.filterBtnDisable = this.sharedService.validationFields.filterBtnDisableForMasterAcc = false;
        this.invalidMasterAcc = this.sharedService.validationFields.invalidMasterAcc = false;
      }
      /* if user clicks to previous active tab then only it will make API call. API call will happen when toggle has been clicked. */
      if (val.tabName === this.sharedService.getSharedConstant.MGP.employeeOrParticipant && (this.toggle || this.isfilterClicked)) {
        this.toggle = false;
        this.isfilterClicked = false;
        this.getClients();
      }
    })
  }

  setPaginationVal() {
    this.pageObject.pageNo = 0;
    if (this.paginator) {
      this.paginator.changePage(0);
    }
    this.getClients();
  }

  customSort(event) {
    if (event.multiSortMeta) {
      const sortArr = this.customSortService.customSort(event);
      if (this.pageObject.sortField !== sortArr) {
        this.isSortingChanged = (JSON.stringify(event.multiSortMeta) === JSON.stringify([this.defaultSortDataField])) ? false : true;
        this.pageObject.pageNo = 0;
        this.pageObject = {
          pageNo: this.pageObject.pageNo,
          pageSize: this.pageObject.pageSize,
          sortField: sortArr
        };
        this.setPaginationVal();
        this.sortClearButtonReset = false;
        if (!this.initialLoad) {
          this.sharedService.clearSuccessMsgs(this.messageService, true);
        } else {
          this.initialLoad = false;
        }
      }
    }
  }

  getClients() {
    let filterObj = {};
    if (this.isfilterClicked) {
      filterObj = {
        masterAccountNum: this.clientsForGlobalRule.get('masterAccount').value ? this.clientsForGlobalRule.get('masterAccount').value : null
      };
      this.sharedService.getEmployeeList(this.pageObject, filterObj, this.masterGroupMode ? this.assignMasterAcctFormData?.id : null, this.masterGroupMode !== 'CREATE' ? this.assignFormData.id : null, null, this.masterGroupMode).subscribe((response) => {
        this.setMasterAccntListData(response);
      });
    } else {
      this.sharedService.getEmployeeList(this.pageObject, '', this.assignMasterAcctFormData?.id, this.masterGroupMode !== 'CREATE' ? this.assignFormData.id : null, null, this.masterGroupMode).subscribe((response) => {
        this.setMasterAccntListData(response);
      });
    }
  }

  setMasterAccntListData(response) {
    if ((this.assignFormData && this.assignFormData.mode === 'EDIT') || (this.assignMasterAcctFormData && this.assignMasterAcctFormData.mode === 'EDIT')) {
      if (response.data !== null) {
        this.formSelectedArr(response.data.content);
      }
    }
    this.clientList = response.data ? response.data.content : response.data;
    this.totalClients = response.data ? response.data.totalElements : 0;
    this.unModifiedRecords = this.clientList;

    /* Set the selected master account value to the selectedOrgIDArr -> Rule step3 */
    if (this.assignFormData.assignOrgIds && this.assignFormData.assignOrgIds.length > 0) {
      this.assignFormData.assignOrgIds.filter(data => this.selectedOrgIDArr.indexOf(data.subAcctNum) === -1 ? this.selectedOrgIDArr.push(data.subAcctNum) : '');
      /* Set the selected clients value to unAssignOrgIds variable for later comparison, to emit the deselected orgIds */
      this.selectedMastrArr = this.assignFormData.assignOrgIds;
      this.selectedArr = this.assignFormData.employeeAccounts;
    }

    /* Set the selected master account value to the selectedOrgIDArr -> Master Group step2 */
    const localFormData = this.assignMasterAcctFormData ? this.assignMasterAcctFormData.employeeGroupAssignInfo : {};
    if (localFormData && localFormData.employeeAccounts && localFormData.employeeAccounts.length > 0) {
      this.selectedMastrArr = localFormData.employeeAccounts;
      this.selectedArr = localFormData.employeeAccounts;
    }

    const editMasterAccountData = (this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP) ? this.assignMasterAcctFormData.employeeGroupAssignInfo : this.assignFormData;
    /* eslint-disable-next-line max-len */
    if ((this.selectedNewRecords.length > 0 || this.alreadySelectedRemoval.length > 0 || this.subAccntNewlySelected.length > 0 ||
      (editMasterAccountData && editMasterAccountData.newSelectedRecords && editMasterAccountData.newSelectedRecords.length > 0) ||
      (editMasterAccountData && editMasterAccountData.subAccntNewlySelected && editMasterAccountData.subAccntNewlySelected.length > 0) ||
      (editMasterAccountData && editMasterAccountData.removedExistingSelected && editMasterAccountData.removedExistingSelected.length > 0)) &&
      (this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP && this.assignMasterAcctFormData.mode === 'EDIT') || this.moduleType === 'Rules') {

      const formSelectedRecords = (editMasterAccountData.newSelectedRecords && editMasterAccountData.newSelectedRecords.length > 0) ? [...editMasterAccountData.newSelectedRecords] : [];
      const formRemovedRecords = (editMasterAccountData.removedExistingSelected && editMasterAccountData.removedExistingSelected.length > 0) ? [...editMasterAccountData.removedExistingSelected] : [];

      const formMultipleSubAccntSelected = (editMasterAccountData.subAccntNewlySelected && editMasterAccountData.subAccntNewlySelected.length > 0) ? [...editMasterAccountData.subAccntNewlySelected] : [];

      const localSelectedArr = (this.selectedNewRecords.length > 0) ? [...this.selectedNewRecords] : [...formSelectedRecords];
      const localRemovedArr = (this.alreadySelectedRemoval.length > 0) ? [...this.alreadySelectedRemoval] : [...formRemovedRecords];

      this.selectedNewRecords = (this.selectedNewRecords && this.selectedNewRecords.length > 0) ? this.selectedNewRecords : [...formSelectedRecords];
      this.selectedMastrArr = (this.selectedNewRecords && this.selectedNewRecords.length > 0) ? this.selectedNewRecords : [...formSelectedRecords];
      this.alreadySelectedRemoval = (this.alreadySelectedRemoval && this.alreadySelectedRemoval.length > 0) ? this.alreadySelectedRemoval : [...formRemovedRecords];

      this.subAccntNewlySelected = (this.subAccntNewlySelected && this.subAccntNewlySelected.length > 0) ? this.subAccntNewlySelected : [...formMultipleSubAccntSelected];

      this.emitNewlySelectedRecords();
      if (localSelectedArr.length > 0 || localRemovedArr.length > 0) {
        this.removeOrAddRecords(localSelectedArr, localRemovedArr);
      }
    }
    this.selectedArr = [...this.selectedArr];
    this.selectedArr.forEach(acct => {
      if(!this.selectedOrgIDArr.some(x => x.subAcctNum === acct.subAcctNum)){
        this.selectedOrgIDArr = [...this.selectedOrgIDArr, acct]
      }
      /* Set the selected clients value to unAssignOrgIds variable for later comparison, to emit the deselected orgIds */
      if(!this.unAssignOrgIds.some(x => x.subAcctNum === acct.subAcctNum)){
        this.unAssignOrgIds = [...this.unAssignOrgIds, acct]
      }
    });
    this.selectedMasterAccounts.emit(this.selectedArr);
    this.getSelectedAccCount(this.selectedArr);
  }

  formSelectedArr(masterAcct) {
    /* Set the selected master account value to the selectedOrgIDArr, the selected master account value can be
     retrieved from the ruleIds list sent for each record in the api response */
    let selectedArr = [];
    const id = this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP ? this.assignMasterAcctFormData.id : this.assignFormData.id;
    masterAcct.forEach((mstrRecord) => {
        const selectedIdArr = this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP ? mstrRecord.groupIds : mstrRecord.ruleIds;
        /* Check if the rule id of the the rule that is been edited is present in the ruleIds list of each record and
        if it is present then push it into the selectedOrgIDArr array to populate the selected master account value */
        if (selectedIdArr && selectedIdArr.indexOf(id) !== -1 && selectedArr.indexOf(mstrRecord) === -1) {
          selectedArr.push(mstrRecord);
        }
    });
    const accountFormData = this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP ? this.assignMasterAcctFormData.employeeGroupAssignInfo.employeeAccounts : this.assignFormData.employeeAccounts;
    selectedArr = selectedArr.length === 0 ? accountFormData : selectedArr;
    if (this.selectedArr.length === 0) {
      selectedArr && selectedArr.forEach((account) => {
        this.insertRecordInArr(account);
      });
    } else {
      const newlySelectedArr = selectedArr;
      newlySelectedArr && newlySelectedArr.forEach((account) => {
        this.insertRecordInArr(account);
      });
    }
  }

  insertRecordInSelectedArr(localSelectedArr) {
   localSelectedArr && localSelectedArr.forEach((account) => {
      this.insertRecordInArr(account);
    });
  }

  insertRecordInArr(account) {
    const index = this.selectedArr.findIndex(x => x.subAcctNum === account.subAcctNum);
    const unassignedIndex = this.unAssignOrgIdsArray.findIndex(x => x === account.subAcctNum);
    if (index === -1 && unassignedIndex === -1) {
      this.selectedArr.push(account);
    }
    if (unassignedIndex !== -1) {
      this.removeRecordFromArr(account);
    }
  }

  removeRecordFromArr(account) {
    const index = this.selectedArr.findIndex(x => x.subAcctNum === account.subAcctNum);
    if (index > -1) {
      this.selectedArr.splice(index, 1);
    }
  }

  getSelectedAccCount(selectedArr) {
    const emitData = {
      selectedOrgIDArr: this.selectedMastrArr,
      unAssignOrgIdsArray: this.unAssignOrgIdsArray,
      selectedArr: (selectedArr)
    };
    this.selectedClients.emit(emitData);
  }

  emitNewlySelectedRecords() {
    if (this.alreadySelectedRemoval.length > 0) {
      this.selectedNewRecords = this.selectedNewRecords.filter((removed) => {
        return !this.alreadySelectedRemoval.find((employee) => {
          return employee.subAcctNum === removed.subAcctNum;
        });
      });
    }

    this.alreadySelectedRemoval.forEach((removed) => {
      removed.selectedAcct = false;
    });

    this.selectedNewRecords.forEach((newSelected) => {
      newSelected.selectedAcct = true;
    });

    if (this.subAccntNewlySelected.length > 0) {
      this.subAccntNewlySelected.forEach((subAcc) => {
        const index = this.alreadySelectedRemoval.findIndex(x => x.subAcctNum === subAcc.subAcctNum);
        if (index !== -1) {
          this.alreadySelectedRemoval.splice(index, 1);
        }
      });
    }

    let localValueIndex = [];
    let localAlreadyRemovedArr = [...this.alreadySelectedRemoval];
    localAlreadyRemovedArr.forEach((selected) => {
      if (selected) {
        localValueIndex = this.unModifiedRecords.filter(item => item.subAcctNum === selected.subAcctNum);
        if (localValueIndex.length > 0 && localValueIndex.every(val => ((this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP && val.groupIds && val.groupIds.indexOf(this.assignMasterAcctFormData.id) !== -1)
          || (this.moduleType === 'Rules' && val.ruleIds && val.ruleIds.indexOf(this.assignFormData.id) !== -1)))) {
          localAlreadyRemovedArr = localAlreadyRemovedArr.filter((removed) => {
            return !localValueIndex.find((account) => {
              return account.subAcctNum === removed.subAcctNum;
            });
          });
        }
      }
    });

    const localFormData = {
      newSelectedRecords: this.selectedNewRecords,
      removedExistingSelected: this.alreadySelectedRemoval,
      subAccntNewlySelected: this.selectedNewRecords,
      localAlreadyRemovedArr
    };
    this.newlySelectedMasterAccounts.emit(localFormData);
  }

  removeOrAddRecords(localSelectedArr, localRemovedArr) {
    this.insertRecordInSelectedArr(localSelectedArr);
    const removedRecords = [...localRemovedArr];
    removedRecords.forEach((emp) => {
      if (this.selectedArr.findIndex(val => (val.subAcctNum === emp.subAcctNum)) >= 0) {
        this.removeRecordFromArr(emp);
      }
    });
  }

  paginate(e) {
    if (this.pageObject.pageNo !== e.page) {
      this.pageObject.pageNo = e.page;
      this.sharedService.clearSuccessMsgs(this.messageService, true);
      this.getClients();
    }
  }

  toggleFunction() {
    this.toggle = !this.toggle;
  }

  onChanges(): void {
    this.clientsForGlobalRule.get('masterAccount').valueChanges.subscribe(value => {
      /* Disable the Apply filter button if value entered in Master Account field is less than 2 character*/
      this.filterBtnDisable = this.sharedService.validationFields.filterBtnDisableForMasterAcc = this.sharedService.isValueLengthGreaterThan2(value);
      this.invalidMasterAcc = this.sharedService.validationFields.invalidMasterAcc = this.sharedService.isValidOrInvalid(value, 'masterAccount', this.clientsForGlobalRule);
      this.sharedService.setErrorMessage(false, this.errMsg);
    });
  }

  clearForm(resetSortFromUI?) {
    this.filterBtnDisable = this.isfilterClicked = false;
    this.pageObject.pageNo = 0;
    this.clientsForGlobalRule.reset();
    this.sharedService.clearSuccessMsgs(this.messageService, true);
    if (resetSortFromUI) {
      this.multiSortMeta = [this.defaultSortDataField];
      this.sortClearButtonReset = true;
    }
    if (!this.sortClearButtonReset) {
      this.getClients();
    }
  }

  applyFilter() {
    this.isfilterClicked = true;
    this.sharedService.clearSuccessMsgs(this.messageService, true);
    this.setPaginationVal();
  }

  onSelectionChange(){
    this.cdr.detectChanges();
  }

  onRowSelect(rowSelectedEvent: TableRowSelectEvent){
    this.selectedOrgIDArr = [...this.selectedOrgIDArr]
    this.getSelectedMasterAccounts(rowSelectedEvent.data);
  }

  onRowUnselect(event: TableRowUnSelectEvent){
    this.selectedOrgIDArr = this.selectedOrgIDArr.filter(x => x !== event.data.subAcctNum)
    this.getSelectedMasterAccounts(event.data);
  }

  onSelectAll(event:TableSelectAllChangeEvent){
    this.toSelectOtherPaginationsList(event);
    this.getSelectedMasterAccounts('');
    this.cdr.detectChanges();
  }

  getSelectedMasterAccounts(selectedVal) {
    this.clientSelected(selectedVal);
    if ((this.moduleType === 'MGP' && this.assignMasterAcctFormData.mode === 'EDIT') || this.moduleType === 'Rules') {
      this.emitNewlySelectedRecords();
    } else {
      this.getSelectedAccCount(this.selectedArr);
      this.selectedArr.forEach((newSelected) => {
        newSelected.selectedAcct = true;
      });
    }
    this.selectedMasterAccounts.emit(this.selectedArr);
    this.rowSelected.emit();
  }

  clientSelected(data) {
    if (data) {
      /* If the selected value is any other client other than Business Unit, then except BU orgId push orgIds of clients selected  */
      this.selection = false;
      /* When all clients are unchecked, then set the selectedMastrArr to empty */
      if (this.selectedOrgIDArr.length === 0) {
        this.selectedMastrArr = [];
        this.selectedArr = [];
        this.removeAlreadySelected(data);
      } else {
        const localArr = this.selectedMastrArr.filter(x => x.subAcctNum === data.subAcctNum);
        if(localArr.length === 0 && this.selectedOrgIDArr.some(x => x.subAcctNum === data.subAcctNum)){
          if(!this.selectedMastrArr.some(x => x.subAcctNum === data.subAcctNum)){
            this.selectedMastrArr = [...this.selectedMastrArr, data]
          }
          if(!this.selectedArr.some(x => x.subAcctNum === data.subAcctNum)){
            this.selectedArr = [...this.selectedArr, data]
          }
          if(!this.subAccntNewlySelected.some(x => x.subAcctNum ===data.subAcctNum )){
            this.subAccntNewlySelected = [...this.subAccntNewlySelected, data]
          }
          const editMasterAccountData = (this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP) ?
            (this.assignMasterAcctFormData && this.assignMasterAcctFormData.employeeGroupAssignInfo) : this.assignFormData;

          let originalSelection = false;
          if (editMasterAccountData && editMasterAccountData.employeeAccounts) {
            originalSelection = editMasterAccountData.employeeAccounts.some(acc => acc.subAcctNum === data.subAcctNum);
          }

          if (!originalSelection && !this.selectedNewRecords.some(x => x.subAcctNum === data.subAcctNum)){
            this.selectedNewRecords = [...this.selectedNewRecords, data]
          }
          // Remove from alreadySelectedRemoval if re-selecting a previously unselected account
          const removalIndex = this.alreadySelectedRemoval.findIndex(x => x.subAcctNum === data.subAcctNum);
          if (removalIndex > -1) {
            this.alreadySelectedRemoval.splice(removalIndex, 1);
          }
        }
        else {
          this.selectedMastrArr = this.selectedMastrArr.filter(x => x.subAcctNum !== data.subAcctNum);
          this.removeRecordFromArr(data);
          this.removeAlreadySelected(data);
        }
      }
    } else if (!data && this.assignMasterAcctFormData?.mode === 'EDIT') {
      /* edit: header checkbox if we need to add all clients*/
      this.addorRemoveClientMultiSelect();

    } else {
      /* If the table-header checkbox is selected, then except BU orgId push all the other orgIds of clients present on that page  */
      this.selection = !this.selection;
      if (!this.selection) {
        this.selectedOrgIDArr = [];
      }
      const localArr = this.selectedOrgIDArr;
      this.selectedMastrArr = [];
      this.selectedOrgIDArr = this.subAccntNewlySelected = [];
      localArr.forEach(val => {
        const account = val;
        this.selectedOrgIDArr = [...this.selectedOrgIDArr, account]
        this.selectedMastrArr = [...this.selectedMastrArr, account]
        if(!this.selectedArr.some(x => x.subAcctNum ===account.subAcctNum) && !this.subAccntNewlySelected.some(x => x.subAcctNum === account.subAcctNum)){
          this.subAccntNewlySelected = [...this.subAccntNewlySelected, account]
          this.selectedArr = [...this.selectedArr, account]
        }
      });
    }
    /* Filter out the orgIds which are present in unAssignOrgIds but not in selectedOrgIDArr, for emitting the orgIds that were deselected */
    this.unAssignOrgIdsArray = this.unAssignOrgIds.filter(x => !this.selectedOrgIDArr.some(y => y.subAcctNum === x.subAcctNum));
    this.emitAssignedAndUnassignedOrgIds();
  }

  removeAlreadySelected(selectedVal) {
    let filteredValue = [];
    if (this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP) {
      filteredValue = [selectedVal.groupIds && (this.moduleType === this.getSharedConstant.manageMasterGroups.groupTypeMGP && selectedVal.groupIds.indexOf(this.assignMasterAcctFormData.id) !== -1)];
    }
    const index = this.alreadySelectedRemoval.findIndex(x => x.subAcctNum === selectedVal.subAcctNum);
    if (index === -1) {
      this.alreadySelectedRemoval.push(selectedVal);
      const localArr = this.alreadySelectedRemoval;
      if (localArr.findIndex(t => (t.subAcctNum === selectedVal.subAcctNum)) >= 0) {
        this.alreadySelectedRemoval.push(selectedVal);
      }

      const parentIndex = this.selectedNewRecords.findIndex(x => x.subAcctNum === selectedVal.subAcctNum);
      if (parentIndex > -1) {
        this.selectedNewRecords.splice(parentIndex, 1);
      }
    }
    this.alreadySelectedRemoval = this.alreadySelectedRemoval.filter((v, i, a) => a.findIndex(t => (t.subAcctNum === v.subAcctNum)) === i);
  }

  emitAssignedAndUnassignedOrgIds() {
    /* emit the assigned and unassigned orgIds to the parent component */
    const emitData = {
      selectedOrgIDArr: this.selectedMastrArr,
      unAssignOrgIdsArray: this.unAssignOrgIdsArray
    };
    this.selectedClients.emit(emitData);
    this.rowSelected.emit();
    this.selectedArr.forEach((newSelected) => {
      newSelected.selectedAcct = true;
    });
    this.selectedMasterAccounts.emit(this.selectedArr);
  }

  /* Method is called when the Business Unit checkbox on under the Master Groups is selected */
  getDatafromParent(data, type, load) {
    if (type) {
      this.getCompanyGrpEmpCount = data.companyGroupEmp;
      this.getCompanyGrpAccCount = data.companyGroupAcc;
    } else {
      this.chkCompanyGrp = data;
      if (data) {
        if (data.length > 0 && data[0].type === 'ORG') {
          this.validateCompanyGrp = data[0].type;
          /* We are assigning all the selected master account to unAssignSelectedMstrAccts when BU is selected to send
          it as part of the payload  */
          const localUnassigenArr = [];
          if (this.assignFormData.empAccounts) {
            this.assignFormData.empAccounts.filter(x => localUnassigenArr.push(x.subAcctNum));
            this.unAssignSelectedMstrAccts.emit(localUnassigenArr);
            this.unAssignOrgIdsArray = localUnassigenArr;
            this.selectedOrgIDArr = [];
            this.selectedArr = [];
            this.selectedMastrArr = [];
          }
         } else {
          if (!load) {
            this.getSelectedCount(this.selectedOrgIDArr);
          }
        }
      }
    }
    this.validateCompanyGrp = data.length > 0 ? data[0].type : '';
  }

  getSelectedCount(selectedArray) {
    const emitData = {selectedArr: selectedArray};
    this.clientsSelection.emit(emitData);
  }
  /* header checkbox for different pagination selection */
  toSelectOtherPaginationsList(event: TableSelectAllChangeEvent){
    if (this.newAllSelectedClients.length === 0) {
      this.newAllSelectedClients.push({
        pageNo: this.pageObject.pageNo,
        checked: event.checked,
        selected: this.selectedOrgIDArr,
      });
    } else if (!this.newAllSelectedClients.some(x=>x.pageNo === this.pageObject.pageNo)) {
      const obj = {
        pageNo: this.pageObject.pageNo,
        checked: event.checked,
        selected: this.selectedOrgIDArr,
      };
      this.newAllSelectedClients.push(obj);
    } else if (this.newAllSelectedClients.some(x => x.pageNo === this.pageObject.pageNo && x.checked !== event.checked)) {
      this.newAllSelectedClients.forEach((e: any) => { e.checked = e.pageNo === this.pageObject.pageNo ? event.checked : e.checked;});
    }
    let arraySelected=[];
    this.newAllSelectedClients.forEach((e: any) => {
      arraySelected = e.checked ? arraySelected.concat(e.selected): arraySelected;
    });
    if (this.assignMasterAcctFormData?.mode === 'EDIT' && arraySelected.length > 0) {
      const mergedArray = arraySelected.concat(this.selectedArr.filter(
        item2 => !arraySelected.some(item1 => item1.subAcctNum === item2.subAcctNum)));
      this.selectedArr = mergedArray;
    } else {
      this.selectedArr = arraySelected.length > 0 ? arraySelected : this.selectedArr;
    }
  }
  addorRemoveClientMultiSelect() {
    const localFilter = this.selectedOrgIDArr;
    if (localFilter.length === 0) {
      let localFilters;
      this.newAllSelectedClients.forEach((e: any) => { localFilters = (e.pageNo === this.pageObject.pageNo && !e.checked) ? e.selected : ''});
      this.selectedMastrArr = this.subAccntNewlySelected =[];
      localFilters && localFilters.forEach(e => {
        this.removeRecordFromArr(e);
        this.removeAlreadySelected(e);
      });
    }
    else {
      localFilter.forEach(e => {
        if (!this.selectedMastrArr.some(x => x.subAcctNum === e.subAcctNum)) {
          this.selectedMastrArr = [...this.selectedMastrArr, e]
        }
        if (!this.selectedArr.some(x => x.subAcctNum === e.subAcctNum)) {
          this.selectedArr = [...this.selectedArr, e]
        }
        if (!this.subAccntNewlySelected.some(x => x.subAcctNum === e.subAcctNum)) {
          this.subAccntNewlySelected = [...this.subAccntNewlySelected, e]
        }
        if (!this.selectedNewRecords.some(x => x.subAcctNum === e.subAcctNum)) {
          this.selectedNewRecords = [...this.selectedNewRecords, e]
        }
      });
    }
  }
}
